import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { EmailFormContext } from '../EmailForm.context'

import * as styles from './EmailCreationFormMassMailingCheckbox.module.css'

function EmailCreationFormMassMailingCheckbox({
  checked,
  className = styles.EmailCreationFormMassMailingCheckbox,
  onChange,
}) {
  const { t } = useTranslation()

  const { massCheckboxDisabled = false } = useContext(EmailFormContext)

  const { isSubmitting } = useFormikContext()

  return (
    <Checkbox
      checked={checked}
      className={className}
      disabled={isSubmitting || massCheckboxDisabled}
      label={t('Email.MassMailingKey')}
      size={CHECKBOX_SIZE.small}
      onChange={onChange}
    />
  )
}

export default EmailCreationFormMassMailingCheckbox
